function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 18h-2a1 1 0 00-.889.541c-.615 1.193-1.951 1.809-3.107 2.126.508-1.011.98-2.309.98-3.636a.998.998 0 00-.629-.928C4.191 15.239 2 13.024 2 10.461 2 6.347 6.486 3 12 3s10 3.347 10 7.461C22 14.618 17.514 18 12 18m0-17c6.617 0 12 4.244 12 9.461C24 15.721 18.617 20 12 20h-1.436c-1.956 2.845-6.341 2.995-6.538 3H4a1.003 1.003 0 01-.782-1.624c.016-.02 1.437-1.828 1.719-3.72C2.446 16.409 0 13.774 0 10.461 0 5.244 5.383 1 12 1zm-.71 13.29c-.18.19-.29.45-.29.71 0 .26.11.52.29.71.19.18.45.29.71.29.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.71-.37-.37-1.04-.37-1.42 0zM12 6c-1.654 0-3 1.346-3 3a1 1 0 002 0c0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1a1 1 0 00-1 1v1c0 .201.074.377.176.534.038.06.066.125.114.176.051.049.118.077.178.115A.976.976 0 0012 13a.973.973 0 00.534-.176c.06-.038.125-.066.176-.114.047-.05.075-.114.111-.172A.97.97 0 0013 12v-.185A2.993 2.993 0 0015 9c0-1.654-1.346-3-3-3z"
});

var SvgIconChatQuestion = function SvgIconChatQuestion(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconChatQuestion;